import KsqlDBStatement from './KsqlDBStatement';

export default KsqlDBStatement;
